module.exports = __webpack_public_path__ + "static/media/connector-line_straight.cb0d764e.svg";